import { PayloadAction } from '@reduxjs/toolkit'
import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IPartner } from 'clickNgo/entities/partner/models'

import { IPartnerState } from '../models'

export const getPartnerByIdPending = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action

  state.partnerData.data = null
  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.PENDING
  state.partnerData.message = ''
}

export const getPartnerByIdRejected = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action

  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.REJECTED
  state.partnerData.message = action.payload as string
}

export const getPartnerByIdFulfilled = (
  state: IPartnerState,
  action: PayloadAction<IPartner, string, { arg: IRequestByPartnerId }>
) => {
  const { meta, payload } = action

  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.FULFILLED
  state.partnerData.message = ''
  if (payload) {
    state.partnerData.data = payload
  }
}
